module.exports = __webpack_public_path__ + "static/images/download.3Fadidc.svg";